import { gql } from "@apollo/client";

export const PatientFragment = gql`
  fragment PatientFragment on Patient {
    id
    name
    surname
    email
    email_verified_at
    created_at
    lastMessage {
      created_at
      content
      is_seen
    }
  }
`;

export const AvailabilityFragment = gql`
  fragment AvailabilityFragment on Availability {
    id
    day
    time_from
    time_to
    created_at
    updated_at
  }
`;

export const BlockedPeriodFragment = gql`
  fragment BlockedPeriodFragment on BlockedPeriod {
    id
    from
    to
  }
`;

export const OncologistFragment = gql`
  fragment OncologistFragment on Oncologist {
    id
    name
    surname
    photo
    role
    bio
    feedbackAvg
    alboRegion {
      id
      name
    }
    albo_number
    policy_number
    availabilities {
      ...AvailabilityFragment
    }
    blockedPeriods {
      ...BlockedPeriodFragment
    }
  }
  ${AvailabilityFragment}
  ${BlockedPeriodFragment}
`;

export const NutrizionistFragment = gql`
  fragment NutrizionistFragment on Nutrizionist {
    id
    name
    surname
    photo
    role
    bio
    alboRegion {
      id
      name
    }
    albo_number
    policy_number
    availabilities {
      ...AvailabilityFragment
    }
    blockedPeriods {
      ...BlockedPeriodFragment
    }
  }
  ${AvailabilityFragment}
  ${BlockedPeriodFragment}
`;

export const GET_PATIENT = gql`
  query getPatient($id: Int!) {
    patient(id: $id) {
      ...PatientFragment
      bio
      credits
      phone
      free_appointment
      consensoInformato {
        id
        professionist_id
      }
      invoice_name
      invoice_surname
      invoice_address
      invoice_cap
      invoice_city
      invoice_province
      invoiceData {
        id
        invoice_file_path
        amount
        invoice_date
        appointment {
          start_at
        }
      }
      appointments {
        id
        start_at
        is_paid
        motivation
        deleted_at
        oncologist {
          ...OncologistFragment
        }
        nutrizionist {
          ...NutrizionistFragment
        }
      }
      oncologist {
        ...OncologistFragment
      }
      nutrizionist {
        ...NutrizionistFragment
      }
    }
  }
  ${OncologistFragment}
  ${NutrizionistFragment}
  ${PatientFragment}
`;

export const GET_FINISHED_APPOINTMENTS_COUNT = gql`
  query finishedAppointmentsCount($id: Int!) {
    finishedAppointmentsCount(professionist_id: $id)
  }
`;

export const GET_ONCOLOGIST = gql`
  query getOncologist($id: Int!) {
    oncologist(id: $id) {
      id
      name
      surname
      email
      studies
      bio
      phone
      photo
      alboRegion {
        id
        name
      }
      albo_number
      policy_number
      patients {
        ...PatientFragment
      }
      appointments {
        id
        start_at
        has_patient_confirmed
        patient {
          ...PatientFragment
        }
      }
      availabilities {
        ...AvailabilityFragment
      }
      blockedPeriods {
        ...BlockedPeriodFragment
      }
    }
  }
  ${AvailabilityFragment}
  ${BlockedPeriodFragment}
  ${PatientFragment}
`;
export const GET_ONCOLOGIST_BLOCKED = gql`
  query getOncologist($id: Int!) {
    oncologist(id: $id) {
      blockedPeriods {
        ...BlockedPeriodFragment
      }
    }
  }
  ${BlockedPeriodFragment}
`;

export const GET_NUTRIZIONIST = gql`
  query getNutrizionist($id: Int!) {
    nutrizionist(id: $id) {
      id
      name
      surname
      email
      studies
      bio
      phone
      photo
      alboRegion {
        id
        name
      }
      albo_number
      policy_number
      appointments {
        id
        start_at
        has_patient_confirmed
        patient {
          ...PatientFragment
        }
      }
      patients {
        ...PatientFragment
      }
      availabilities {
        ...AvailabilityFragment
      }
      blockedPeriods {
        ...BlockedPeriodFragment
      }
    }
  }
  ${AvailabilityFragment}
  ${BlockedPeriodFragment}
  ${PatientFragment}
`;

export const GET_NUTRIZIONIST_BLOCKED = gql`
  query getNutrizionist($id: Int!) {
    nutrizionist(id: $id) {
      blockedPeriods {
        ...BlockedPeriodFragment
      }
    }
  }
  ${BlockedPeriodFragment}
`;

export const GET_NOTIFICATIONS = gql`
  query getNotifications {
    notifications {
      id
      content
    }
  }
`;

export const GET_ONCOLOGIST_PATIENTS = gql`
  query getOncologist($id: Int!) {
    oncologist(id: $id) {
      patients {
        id
        name
        surname
        email_verified_at
        created_at
        lastMessage {
          created_at
          content
          is_seen
        }
      }
    }
  }
`;

export const GET_NUTRIZIONIST_PATIENTS = gql`
  query getNutrizionistPatients($id: Int!) {
    nutrizionist(id: $id) {
      patients {
        id
        name
        surname
        email_verified_at
        lastMessage {
          created_at
          content
          is_seen
        }
      }
    }
  }
`;

export const userQuery = {
  patient: GET_PATIENT,
  oncologist: GET_ONCOLOGIST,
  nutrizionist: GET_NUTRIZIONIST,
};

export const patientsQuery = {
  oncologist: GET_ONCOLOGIST_PATIENTS,
  nutrizionist: GET_NUTRIZIONIST_PATIENTS,
};
export const userBlockedPeriodsQuery = {
  patient: GET_PATIENT, // @TODO: remove and fix type
  oncologist: GET_ONCOLOGIST_BLOCKED,
  nutrizionist: GET_NUTRIZIONIST_BLOCKED,
};
